<template>
	<div class="swiper-container">
		<div class="swiper-wrapper" :style="{width: bigImgW +'px'}" @mouseover="stopMove" @mouseout="beginMove">
            <div class="swiper-main" :style="{width: bigImgW +'px',height: bigImgH+'px'}">
                <ul :style="{width: com_mainWidth +'px'}" ref="bigImgUl" class="clearfix">
                    <li v-for="(item,index) of piclist" :key="index">
                        <img :src="item.imgSrc" :style="{width: bigImgW +'px',height: bigImgH+'px'}"/>
                    </li>
                </ul>
            </div>
            <div class="swiper-slide-cir" v-if="!isShowSPIC">
                <span v-for="(item,index) of piclist"
                :key="index"
                :class="{on: index === chioceIndex}"
                @click="chioceItem2(item, index)">
                {{index+1}}</span>
            </div>
            <div class="swiper-slide" :style="{width: bigImgW +'px'}" v-if="isShowSPIC">
                <ul :style="{width: com_slideWidth +'px'}" ref="smallImgUl" class="clearfix">
                    <li v-for="(item,index) of piclist"
                        :key="index"
                        :class="{on: index === chioceIndex}"
                        :style="{width: smallImgW +'px',height: smallImgH +'px',}"
                        @click="chioceItem(item, index)">
                        <img :src="item.imgSrc" />
                    </li>
                </ul>
                <span class="arrow arrowLeft" @click="toLeft"></span>
                <span class="arrow arrowRight" @click="toRight"></span>
            </div>
        </div>
	</div>
</template>

<script>
  export default {
        data() {
            return {
                test: 'abc',
                chioceIndex:0,
                bigImgW: this.bigImgWidth,
                bigImgH: this.bigImgHeight,
                smallImgW: this.smallImgWidth,
                smallImgH: this.smallImgHeight,
                isPlay: this.isAutoPlay,
                isShowSPIC: this.isShowSmall,
                moveSpeed: this.speed,
                startMoveIndex: 0,
                transformLateX:0,
                showCount: 0,
                playTimer: null,
                piclist: this.picList
            }
        },
        props:{
            bigImgWidth:{
                type: Number,
                default: 300
            },
            bigImgHeight:{
                type: Number
            },
            smallImgWidth:{
                type: Number,
                default: 80
            },
            smallImgHeight:{
                type: Number,
                default: 80
            },
            isAutoPlay:{
                type: Boolean,
                default: false
            },
            isShowSmall:{
                type: Boolean,
                default: false
            },
            speed:{
                type: Number,
                default: 3000
            },
            clearTime:{
                type: Boolean,
                default: false
            },
            picList:{
                type: Array
            }
        },
        watch:{
            clearTime(cur, pre){
                if(cur){
                    this.stopMove();
                }
            },
            picList(cur, pre){
                console.log(cur)
                if(cur){
                    this.piclist = cur;
                }
            }
        },
        computed:{
            com_mainWidth(){
                return this.bigImgW * this.piclist.length
            },
            com_slideWidth(){
                return this.smallImgW * this.piclist.length
            },
            remainOffsetLeft(){
                return this.com_slideWidth - this.bigImgW;
            }
        },
        methods: {
            chioceItem(item, index){
                if (this.chioceIndex === index) {
                    return;
                }
                this.chioceIndex = index;
                if (index >= this.chioceIndex){
                    this.$refs.bigImgUl.style.transform = `translateX(-${this.chioceIndex * this.bigImgW}px)`
                } else {
                    this.$refs.bigImgUl.style.transform = `translateX(${this.chioceIndex * this.bigImgW}px)`
                }
                this.autoChange();
            },
            chioceItem2(item, index){
                if (this.chioceIndex === index) {
                    return;
                }
                this.chioceIndex = index;
                if (index >= this.chioceIndex){
                    this.$refs.bigImgUl.style.transform = `translateX(-${this.chioceIndex * this.bigImgW}px)`
                } else {
                    this.$refs.bigImgUl.style.transform = `translateX(${this.chioceIndex * this.bigImgW}px)`
                }
                //this.autoChange();
            },
            toLeft(){
                this.chioceIndex--;
                if(this.chioceIndex < 0){
                    this.chioceIndex = this.piclist.length-1;
                    this.$refs.bigImgUl.style.transform = `translateX(-${this.chioceIndex * this.bigImgW}px)`
                    this.$refs.smallImgUl.style.transform = `translateX(-${this.remainOffsetLeft}px)`
                    this.transformLateX = this.com_slideWidth - this.showCount*this.smallImgWidth;
                    this.startMoveIndex = this.piclist.length- this.showCount;
                } else {
                    this.$refs.bigImgUl.style.transform = `translateX(-${this.chioceIndex * this.bigImgW}px)`
                }
                if (this.isShowSmall){
                    this.autoChange();
                }
            },
            toRight(){
                this.chioceIndex++;
                if(this.chioceIndex  === this.piclist.length){
                    this.chioceIndex = 0;
                    this.$refs.bigImgUl.style.transform = `translateX(0)`
                    if (this.$refs.smallImgUl) {
                        this.$refs.smallImgUl.style.transform = `translateX(0)`
                    }
                    this.transformLateX = 0;
                    this.startMoveIndex = 0;
                } else {
                    this.$refs.bigImgUl.style.transform = `translateX(-${this.chioceIndex * this.bigImgW}px)`
                }
                if (this.isShowSmall){
                    this.autoChange();
                }

            },
            autoPlay(){
                clearInterval(this.playTimer);
                this.playTimer = setInterval(()=>{
                    this.toRight();
                },this.moveSpeed)
            },
            beginMove(){
                if (this.isPlay){
                    this.autoPlay();
                }
            },
            stopMove(){
                clearInterval(this.playTimer);
            },
            autoChange(){
                let digit = this.piclist.length / this.showCount;

                if (digit > 0){
                    if ( Math.ceil(this.transformLateX/this.smallImgWidth + this.showCount) === this.chioceIndex+1){
                        if (this.transformLateX === this.remainOffsetLeft) return;
                        this.startMoveIndex++;
                        this.transformLateX = this.startMoveIndex * this.smallImgWidth;
                        this.$refs.smallImgUl.style.transform = `translateX(-${this.transformLateX}px)`

                    }
                    if (this.transformLateX !== 0 && this.transformLateX === this.chioceIndex * this.smallImgWidth){
                        this.startMoveIndex--;
                        this.transformLateX = this.startMoveIndex * this.smallImgWidth;
                        this.$refs.smallImgUl.style.transform = `translateX(-${this.transformLateX}px)`
                    }

                }

            }
        },
        beforeDestroy(){
          if(this.playTimer){
            clearInterval(this.playTimer)
          }
        },
        components: {

        },
        mounted(){
            this.$nextTick(()=>{
                this.showCount = this.bigImgWidth / this.smallImgWidth;
                if (this.isPlay){
                    this.autoPlay();
                }
            })
        }
    }

</script>
<style lang="less">

    .bgposition(@ad:'', @w:0, @h:0){
        background: rgba(255,255,255,.5) url(@ad) no-repeat @w @h;
    }
	.swiper-wrapper{
        background: #f1f1f1;
        position: relative;
		.swiper-main{
            overflow: hidden;
            ul{
                -webkit-transition:all ease .5s;
                transition: all ease .5s;
                li{
                    float: left;
                }
            }
        }
        .swiper-slide-cir{
            position: absolute;
            width: 100%;
            left: 0;
            bottom:30px;
            text-align: center;
            span{
                display: inline-block;
                width: 15px;
                height: 15px;
                background: #fff;
                cursor: pointer;
                margin: 0 5px;
                text-indent: -9999px;
                &.on{
                    -webkit-transition:all ease .5s;
                    transition: all ease .5s;
                    background: #729bf0;
                }
            }
        }
        .swiper-slide{
            margin: 10px 0 0;
            position: relative;
            overflow: hidden;
            ul{
                margin: 0 auto;
                -webkit-transition:all ease .5s;
                transition: all ease .5s;
                li{
                    float: left;
                    position: relative;
                    overflow: hidden;
                    &.on{
                        &::before{
                            position: absolute;
                            content: "";
                            width:100%;
                            height:100%;
                            left:0;
                            top:0;
                            border: 2px solid #7FB6F8;
                            box-sizing: border-box;
                        }
                    }
                    img{
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            span{
                &.arrow{
                    position: absolute;
                    width: 40px;
                    height: 100%;
                    top: 0;
                    cursor: pointer;
                    z-index: 2;
                }
                &.arrowLeft{
                    left: 0;
                    .bgposition('../../assets/images/feel3.png',center,center)
                }
                &.arrowRight{
                    right: 0;
                    .bgposition('../../assets/images/feel4.png',center,center)
                }
            }
        }
		h2{
			color: red;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/swiper/Swiper.vue